import { createFileRoute, useNavigate } from "@tanstack/react-router";
import type { FeedbackFilters } from "../../../api/admin";
import { FeedbackPage } from "../../../components/admin/feedback/FeedbackPage";

// The Feedback page and scorecard (PLAN §8.9, D25; R5 contract 20). Its filters live in the URL.

const DAY = /^\d{4}-\d{2}-\d{2}$/;

function str(v: unknown): string | undefined {
  return typeof v === "string" && v ? v : undefined;
}

export const Route = createFileRoute("/_app/admin/feedback")({
  validateSearch: (s: Record<string, unknown>): FeedbackFilters => {
    const out: FeedbackFilters = {};
    if (s.rating === "up" || s.rating === "down") out.rating = s.rating;
    if (s.flagged === true || s.flagged === "1" || s.flagged === 1) out.flagged = true;
    for (const key of ["reason", "team", "person"] as const) {
      const v = str(s[key]);
      if (v) out[key] = v;
    }
    for (const key of ["from", "to"] as const) {
      const v = str(s[key]);
      if (v && DAY.test(v)) out[key] = v;
    }
    return out;
  },
  component: Feedback,
});

function Feedback() {
  const filters = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <FeedbackPage
      filters={filters}
      onFilters={(next) =>
        navigate({
          search: Object.fromEntries(
            Object.entries(next).filter(([, v]) => v !== undefined && v !== ""),
          ) as FeedbackFilters,
          replace: true,
        })
      }
    />
  );
}
